import { Box, Skeleton } from "@mui/material";

export default function SkeletonCropTable() {
  return (
    <>
      <SkeletonDashboardOverviewCards />
      {/* TODO Make tableSkeleton */}
    </>
  );
}

function SkeletonDashboardOverviewCards() {
  return (
    <Box
      sx={{
        width: "100%",
        backgroundColor: "var(--background-section)",
        borderRadius: "2.375rem",
        padding: {
          xs: "0.375rem",
          sm: "1rem",
          md: "1rem",
          lg: "1.375rem",
        },
        marginBottom: "1.5rem",
        display: "flex",
        flexDirection: { xs: "column", sm: "column", md: "column", lg: "row" },
        gap: "0.75rem",
      }}
    >
      {[...Array(3)].map((_, idx) => (
        <Box
          key={idx}
          sx={{
            display: "flex",
            flex: 1,
            flexDirection: { xs: "column", sm: "row", md: "row", lg: "column" },
            gap: { xs: "0.375rem", sm: "0.75rem", md: "0.75rem", lg: "0.75rem" },
          }}
        >
          <Box
            sx={{
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
              flexDirection: "column",
              backgroundColor: "white",
              borderRadius: "999px",
              padding: "0.875rem",
              gap: "0.25rem",
              flex: 1,
            }}
          >
            <Skeleton variant="text" width="70%" sx={{ fontSize: "1.25rem", fontWeight: "800" }} />
            <Skeleton variant="text" width="60%" sx={{ fontSize: "1rem", fontWeight: "600" }} />
          </Box>
          <Box
            sx={{
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
              flexDirection: "column",
              backgroundColor: "var(--background-card-secondary)",
              borderRadius: "999px",
              padding: "0.5rem 0.875rem",
              gap: "0.25rem",
              flex: 1,
            }}
          >
            <Skeleton variant="text" width="70%" sx={{ fontSize: "1.125rem", fontWeight: "800" }} />
            <Skeleton variant="text" width="60%" sx={{ fontSize: "0.875rem", fontWeight: "600" }} />
          </Box>
        </Box>
      ))}
    </Box>
  );
}
